module.exports = __webpack_public_path__ + "svg/flags/Taiwan, Province of China.svg";